import DelayedCloseButton from '../../../components/DelayedCloseButton/DelayedCloseButton'
import FeatureTermsList from '../../../components/FeatureTermsList/FeatureTermsList'
import FullScreenPage from '../../../components/FullScreenPage/FullScreenPage'
import UltimateSubfeaturesPopups from '../../../components/UltimateSubfeaturesPopups/UltimateSubfeaturesPopups'
import { useBlackFriday } from '../../../context/blackFridayContext'
import useStrings from '../../../localization/useStrings'
import native from '../../../native/native'
import images from '../../../utils/images'
import svg from '../../../utils/svg'
import Countdown from '../Countdown/Countdown'
import PromoRegularFooter from './PromoRegularFooter/PromoRegularFooter'
import styles from './PromoRegularPaywall.module.scss'

const PromoRegularPaywall = () => {
  return (
    <FullScreenPage containerClassName={styles.page}>
      <div className={styles.decoration}>
        <img className={images.backgroundPatternLarge.class} />
      </div>
      <UltimateSubfeaturesPopups />
      <div className={styles.container}>
        <Header />
        <div className={styles.scrollableList}>
          <FeatureTermsList />
        </div>
        <PromoRegularFooter />
      </div>
    </FullScreenPage>
  )
}

const Header = () => {
  const strings = useStrings()
  const isUltimate = useBlackFriday().state.isUltimate
  const Icon = isUltimate ? svg.UltimateIcon : svg.PremiumIcon

  return (
    <div className={styles.headerContainer}>
      <DelayedCloseButton
        className={styles.close}
        onClick={() => {
          native.postNativeEvent("close")
        }}
      />
      <div className={styles.icon}>
        <Icon width={32} height={32} fill="white" />
      </div>
      <label className={styles.title}>{strings.blackFridayPaywallTitle}</label>
      <label className={styles.subtitle}>{strings.blackFridayPaywallSubtitle}</label>
      <Countdown showExpires={false} />
      <label className={styles.expires}>{strings.offerExpires}</label>
    </div>
  )
}

export default PromoRegularPaywall
